// import Header from "../components/Common/Header";
import ProjectList from "../components/ProjectList";
import Footer from "../components/Common/Footer";
import OhYogaMainBanner from "../components/OhYogaMainBanner";
import SectionBannerDownload from "../components/SectionBannerDownload";

export default function OhYogaScreen() {
  return (
    <div className="page__content page__content--with-header page__content--with-bottom-nav mx-auto">
      {/* <Header bgColor="bg-amber-50" logo="/logo-b.png" /> */}
      <OhYogaMainBanner
        firstTitle="Project 01"
        lastName="OhYoga"
        desc="OhYoga는 요가를 좋아하는 사람들로 아쉬탕가 요가 수련을 해본 적이 있지만 순서나 호흡법이 헷갈리거나 익숙하지 않은 분들께 추천드려요.
        아쉬탕가 요가는 유연성을 키워줄 뿐만 아니라 유산소는 물론 근육을 강화하는 동작이 많아서 근력 운동으로도 효과가 좋습니다."
        img="/assets/images/project/ohyoga/screen1.png"
      />
      <SectionBannerDownload iosLink="https://apps.apple.com/kr/app/oh-yoga/id6448233548" />
      <ProjectList />
      <Footer
        email="oying212@icloud.com"
        desc="The 6-Pack includes two black, two white, and two heather gray
              Basic Tees. Sign up for our subscription service and be the first
              to get new, exciting colors, like our upcoming"
      />
    </div>
  );
}
